import {getAPIGatewayPostRequest} from "../../../../util/Util";
import {
    AISLE,
    ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT,
    LED_CONTROLLER_ASSET_TYPE, OFF_STATE,
    ON_STATE
} from "../../../../util/Constants";
import {getAPIGatewayDataFromParent} from "../../../../handler/ParentDataHandler";

class AisleController {
    constructor(siteId, controllerIp) {
        this.siteId = siteId;
        this.controllerIp = controllerIp;
    }

    async start(portIds, patternId, durationMs) {
        const request = {
            nodeId : this.siteId,
            assetType : LED_CONTROLLER_ASSET_TYPE,
            commandParams : {
                locationType : AISLE,
                state : ON_STATE,
                color : patternId,
                durationMs : durationMs.toString(),
                controllerIp : this._getLedControllerId(),
                portIds : portIds
            }
        }
        const args = getAPIGatewayPostRequest(request, ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT);
        await getAPIGatewayDataFromParent(args);
    }

    async stopAll() {
        const request = {
            nodeId : this.siteId,
            assetType : LED_CONTROLLER_ASSET_TYPE,
            commandParams : {
                locationType : AISLE,
                state : OFF_STATE,
                controllerIp : this._getLedControllerId()
            }
        }
        const args = getAPIGatewayPostRequest(request, ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT);
        await getAPIGatewayDataFromParent(args);
    }

    _getLedControllerId() {
        return this.controllerIp == null ? '' : this.controllerIp;
    }
}

export default AisleController;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/business/aisle-controller.js